import React from 'react';
import clsx from 'clsx';
import Icon from '@components/Icon';
import DropdownMenu, { DropdownMenuOption } from '@components/DropdownMenu';
import NetworkIcon from '@components/NetworkIcon';
import { Network } from '@types';

interface NetworkSelectProps {
  className?: string;
  label: string;
  onChange(value: Network): void;
  options: Array<DropdownMenuOption>;
  value: Network;
}

const NetworkSelect = ({
  className = '',
  label,
  onChange,
  options,
  value,
}: NetworkSelectProps) => {
  const displayNetwork = options.find(
    (option) => option.value === value
  )?.label;

  return (
    <div className={clsx(['relative', className])}>
      <div className="text-left text-micro text-white">
        <p>{label}</p>
      </div>
      <DropdownMenu
        value={value}
        onChange={onChange}
        options={options}
        className="text-smallSemibold w-full"
      >
        {(props) => (
          <button
            className="tablet:flex text-left w-full items-center p-2 tablet:p-3 bg-black text-white rounded-medium shadow-default cursor-pointer"
            {...props}
          >
            <NetworkIcon variant={value} className="text-iconXLarge mr-1" />
            <div className="flex-1 flex items-center mt-1 tablet:mt-0">
              <div className="text-smallSemibold font-semibold flex-1">
                {displayNetwork}
              </div>
              <Icon.ArrowDown className="ml-auto text-iconLarge" />
            </div>
          </button>
        )}
      </DropdownMenu>
    </div>
  );
};

export default NetworkSelect;
